import React, { useEffect, useRef, useState } from 'react'
import { v4 } from 'uuid'

import PropertyMinimalCard from '../../cards/property/minimal'
import ListControls from './constrols'
import * as S from './styled'

interface MinimalPropertiesList {
  properties?: any[]
  CustomCard?: (props: any) => JSX.Element
  buttonColors?: { background: string; icon: string }
  black?: boolean
  redirectWithBlank?: boolean
  onClickCard?: (e?: any) => void
  slidesPerView?: number
}

const MinimalCard = PropertyMinimalCard as any

const OldMinimalList = ({
  properties = [],
  buttonColors = { background: 'black.0', icon: 'black' },
  CustomCard,
  redirectWithBlank = true,
  onClickCard,
}: MinimalPropertiesList) => {
  const listRef = useRef<HTMLDivElement>(null)
  const cardRef = useRef<HTMLDivElement>(null)
  const [leftScrolled, setLeftScrolled] = useState(0)
  const [scrollValidation, setScrollValidation] = useState(false)

  useEffect(() => {
    if (!listRef.current) return
    if (!cardRef?.current) return

    const cardWidth =
      (cardRef?.current?.clientWidth + 10) *
        listRef.current?.childElementCount -
      listRef?.current?.scrollLeft

    return setScrollValidation(cardWidth <= listRef.current?.clientWidth)
  }, [
    cardRef.current?.clientWidth,
    listRef.current?.childElementCount,
    listRef.current?.scrollLeft,
  ])

  return (
    <S.ListContainer>
      <S.ContentList
        onScroll={(e) => setLeftScrolled(e.target.scrollLeft)}
        ref={listRef}
      >
        {properties.map((p) => (
          <React.Fragment key={v4()}>
            {CustomCard ? (
              <CustomCard
                {...p}
                onClick={() => onClickCard?.(p)}
                redirectWithBlank={redirectWithBlank}
                property={p}
                ref={cardRef}
              />
            ) : (
              <MinimalCard
                redirectWithBlank={redirectWithBlank}
                onClick={() => onClickCard?.(p)}
                property={p}
                ref={cardRef}
              />
            )}
          </React.Fragment>
        ))}
      </S.ContentList>
      <ListControls
        listRef={listRef}
        leftScrolled={leftScrolled}
        scrollValidation={scrollValidation}
        cardWidth={cardRef.current && cardRef?.current?.clientWidth + 1}
        buttonColors={buttonColors}
      />
    </S.ListContainer>
  )
}

export default OldMinimalList
